import Permission from 'owa-service/lib/contract/Permission';
/**
 * Function that determines if the arrays of permission are equal or not
 * @param permissionArray1 first permission array
 * @param permissionArray2 second permission array
 * @returns true if arrays of permission are same
 */
export function arePermissionArraysEqual(
    permissionArray1: Permission[],
    permissionArray2: Permission[]
): boolean {
    if (!permissionArray1 && !permissionArray2) {
        return true;
    } else if (!permissionArray1 || !permissionArray2) {
        return false;
    } else {
        if (permissionArray1.length !== permissionArray2.length) {
            return false;
        }
        // Check if arrays of permissions are unequal.
        // Code below will break the iteration as soon as the condition is satisfied.
        const isPermissionArraysUnequal: boolean = permissionArray1.some((permission, idx) => {
            // Check if permissions are not equal.
            return !arePermissionsEqual(permission, permissionArray2[idx]);
        });
        return !isPermissionArraysUnequal;
    }
}

/**
 * Function that determines if the permissions are equal or not
 * @param permission1 first permission
 * @param permission2 second permission
 * @returns true if permissions are same
 */
export function arePermissionsEqual(permission1: Permission, permission2: Permission): boolean {
    if (!permission1 && !permission2) {
        return true;
    } else if (!permission1 || !permission2) {
        return false;
    } else {
        const keys = Object.keys(permission1);
        // Check if permissions are unequal.
        // Code below will break the iteration as soon as the it finds any property whose values are different.
        const arePermissionsUnequal: boolean = keys.some(key => {
            // Comparing UserId property.
            if (key === 'UserId') {
                const userId = permission1[key];
                if (userId.PrimarySmtpAddress) {
                    return userId.PrimarySmtpAddress !== permission2[key].PrimarySmtpAddress;
                } else {
                    return userId.DistinguishedUser !== permission2[key].DistinguishedUser;
                }
            } else {
                return permission1[key] !== permission2[key];
            }
        });
        return !arePermissionsUnequal;
    }
}
